import { render } from "./NeobuqEconomicView.vue?vue&type=template&id=a6405dda&scoped=true"
import script from "./NeobuqEconomicView.vue?vue&type=script&lang=js"
export * from "./NeobuqEconomicView.vue?vue&type=script&lang=js"

import "./NeobuqEconomicView.vue?vue&type=style&index=0&id=a6405dda&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6405dda"]])

export default __exports__